(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-promo-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-promo-slider')) {
 customElements.define('mc-promo-slider', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.track = this.querySelector('.mc-promo-track');
   this.cards = Array.from(this.track.children);
   this.progress = this.querySelector('.mc-promo-progress');
   this.arrows = this.querySelectorAll('[data-direction]');
   this.toggle = this.querySelector('[data-autoplay-toggle]');
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
   this.editor = Boolean(window.Shopify && window.Shopify.designMode);
   this.inView = false;
   if (!this.cards.length) return;
   if (this.cards.length > 1) {
    this.cards.forEach(card => {
     const copy = card.cloneNode(true);
     copy.dataset.loopCopy = '';
     copy.setAttribute('aria-hidden', 'true');
     copy.setAttribute('tabindex', '-1');
     copy.removeAttribute('id');
     copy.removeAttribute('data-shopify-editor-block');
     copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
     copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
     this.track.append(copy);
    });
   }
   this.arrows.forEach(button => button.addEventListener('click', () => this.advance(Number(button.dataset.direction)), { signal }));
   this.toggle?.addEventListener('click', () => {
    this.paused = !this.paused;
    this.syncToggle();
    this.schedule();
   }, { signal });
   this.addEventListener('mouseenter', () => this.stopTimer(), { signal });
   this.addEventListener('mouseleave', () => this.schedule(), { signal });
   this.addEventListener('focusin', () => this.stopTimer(), { signal });
   this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0), { signal });
   this.track.addEventListener('pointerdown', () => { this.dragging = true; this.stopAnimation(); this.stopTimer(); }, { signal, passive: true });
   window.addEventListener('pointerup', () => { this.dragging = false; this.schedule(); }, { signal, passive: true });
   window.addEventListener('pointercancel', () => { this.dragging = false; this.schedule(); }, { signal, passive: true });
   this.track.addEventListener('wheel', () => { this.stopAnimation(); this.stopTimer(); }, { signal, passive: true });
   this.track.addEventListener('scroll', () => {
    this.update();
    if (this.animating) return;
    this.stopTimer();
    clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(() => { this.normalize(); this.schedule(); }, 160);
   }, { signal, passive: true });
   document.addEventListener('visibilitychange', () => {
    if (document.hidden) { this.stopTimer(); this.stopAnimation(); } else this.schedule();
   }, { signal });
   this.motion.addEventListener('change', () => {
    if (this.motion.matches) { this.paused = true; this.stopAnimation(); }
    this.syncToggle();
    this.schedule();
   }, { signal });
   this.addEventListener('shopify:block:select', event => {
    this.stopAnimation();
    this.stopTimer();
    const card = event.target.closest('.mc-promo-card');
    if (card && this.cards.includes(card)) this.track.scrollLeft = this.cards.indexOf(card) * this.step;
   }, { signal });
   this.resizeObserver = new ResizeObserver(() => {
    const index = this.step ? Math.round(this.track.scrollLeft / this.step) % this.cards.length : 0;
    this.stopAnimation();
    this.step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
    this.loopWidth = this.cards.length * this.step;
    this.track.classList.add('is-sliding');
    this.track.scrollLeft = index * this.step;
    this.track.classList.remove('is-sliding');
    this.update();
    this.schedule();
   });
   this.resizeObserver.observe(this.track);
   this.intersectionObserver = new IntersectionObserver(entries => {
    this.inView = entries[0].isIntersecting;
    this.schedule();
   }, { threshold: 0.15 });
   this.intersectionObserver.observe(this);
   this.syncToggle();
  }
  stopTimer() { clearTimeout(this.timer); }
  stopAnimation() {
   cancelAnimationFrame(this.frame);
   this.animating = false;
   this.track?.classList.remove('is-sliding');
  }
  syncToggle() {
   if (!this.toggle) return;
   this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
   this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
   this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
  }
  schedule() {
   this.stopTimer();
   if (!this.isConnected || this.paused || this.editor || this.motion.matches || document.hidden || !this.inView || this.dragging || this.animating || this.matches(':hover, :focus-within') || this.cards.length < 2 || !this.step) return;
   this.timer = setTimeout(() => this.advance(1), Number(this.dataset.interval) || 5000);
  }
  normalize() {
   if (!this.loopWidth || this.track.scrollLeft < this.loopWidth - 1) return;
   this.track.classList.add('is-sliding');
   this.track.scrollLeft %= this.loopWidth;
   this.track.classList.remove('is-sliding');
   this.update();
  }
  update() {
   if (!this.step) return;
   const index = Math.round(this.track.scrollLeft / this.step) % this.cards.length;
   const value = (index + 1) + ' / ' + this.cards.length;
   if (this.progress.textContent !== value) this.progress.textContent = value;
   this.arrows.forEach(button => { button.disabled = this.cards.length < 2; });
  }
  advance(direction) {
   if (!this.step || this.cards.length < 2) return;
   this.stopTimer();
   this.stopAnimation();
   clearTimeout(this.settleTimer);
   this.normalize();
   this.animating = true;
   this.track.classList.add('is-sliding');
   let start = this.track.scrollLeft;
   if (direction < 0 && start < 1) { start = this.loopWidth; this.track.scrollLeft = start; }
   const target = Math.round(start / this.step) * this.step + direction * this.step;
   const duration = this.motion.matches ? 0 : Number(this.dataset.duration) || 1400;
   const started = performance.now();
   const tick = now => {
    if (!this.isConnected) return;
    const fraction = duration ? Math.min(1, (now - started) / duration) : 1;
    const eased = fraction * fraction * (3 - 2 * fraction);
    this.track.scrollLeft = start + (target - start) * eased;
    this.update();
    if (fraction < 1) this.frame = requestAnimationFrame(tick);
    else {
     this.track.scrollLeft = ((target % this.loopWidth) + this.loopWidth) % this.loopWidth;
     this.track.classList.remove('is-sliding');
     this.animating = false;
     this.update();
     this.schedule();
    }
   };
   this.frame = requestAnimationFrame(tick);
  }
  disconnectedCallback() {
   this.stopTimer();
   this.stopAnimation();
   clearTimeout(this.settleTimer);
   this.controller?.abort();
   this.resizeObserver?.disconnect();
   this.intersectionObserver?.disconnect();
   this.querySelectorAll('[data-loop-copy]').forEach(copy => copy.remove());
   this.controller = null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-request-notice"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-store-notice')) {
 customElements.define('mc-store-notice', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const openFromLink = () => {
    if (window.location.hash !== '#mc-product-request') return;
    const details = this.querySelector('details');
    details.open = true;
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => details.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
   };
   window.addEventListener('hashchange', openFromLink, {signal:this.controller.signal});
   openFromLink();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; cancelAnimationFrame(this.frame); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
